import { render, staticRenderFns } from "./LaoChow.vue?vue&type=template&id=6b9971b8&"
import script from "./LaoChow.vue?vue&type=script&lang=js&"
export * from "./LaoChow.vue?vue&type=script&lang=js&"
import style0 from "./LaoChow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports